import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Box, Button} from '@mui/material';
import {Panel} from '../../components/Panel/Panel';
import TasksGrid from '../../features/tasks/TasksGrid/TasksGrid';
import {useAccountContext} from '../../contexts/AccountContext';
import {HandoverStep} from '../../components/HandoverStep/HandoverStep';
import {HandoverFooterNavigation} from '../../components/FooterNavigation/HandoverFooterNavigation';
import {themeColors} from '../../theme/Theme';
import {useReviewContext} from '../../contexts/ReviewContext';
import useTitle from '../../hooks/useTitle';

export default function Tasks() {
  const navigate = useNavigate();
  const {isFullySubmitted} = useReviewContext();

  return (
    <Panel color={themeColors.tan} title="Tasks">
      <Box mb={1} mt={1}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            navigate({pathname: '../tasks-builder'});
          }}
          disabled={isFullySubmitted}
        >
          New task
        </Button>
      </Box>
      <TasksGrid readOnly={isFullySubmitted} />
      <div style={{paddingBottom: 100}} />
    </Panel>
  );
}

export const ClientTasksPage: React.FC = () => {
  const {account} = useAccountContext();
  useTitle(`Tasks - ${account?.name}`);
  return <Tasks />;
};

export const HandoverTaskPage: React.FC = () => {
  const {account} = useAccountContext();
  useTitle(`Review tasks - ${account?.name}`);
  return (
    <>
      <HandoverStep />
      <Tasks />
      {/* this prevents the footer from obscuring the contents above */}
      <div style={{height: '4rem'}} />
      <HandoverFooterNavigation />
    </>
  );
};
